import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d72768db855e6b44a25d8c4264972596.jpg"
          alt="Premium landscape design"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-12">
            <Link to="/" className="flex items-center gap-3">
              <div className={`text-2xl font-bold tracking-tight ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                ScapeWorx
              </div>
            </Link>
            <div className="hidden lg:flex items-center gap-8">
              <Link to="/" className={`text-sm font-medium hover:text-[#E67E22] transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}>Home</Link>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <a href="tel:6105550123" className={`hidden md:flex items-center gap-2 text-sm font-semibold whitespace-nowrap ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              <i className="ri-phone-line text-lg"></i>
              (610) 555-0123
            </a>
            <Link to="/estimate" className="bg-[#E67E22] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#D35400] transition-all shadow-lg whitespace-nowrap cursor-pointer">
              Free Estimate
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative h-full flex items-center">
        <div className="max-w-[1400px] mx-auto px-6 w-full">
          <div className="max-w-2xl">
            {/* Floating Panel */}
            <div className="bg-black/40 backdrop-blur-md rounded-3xl p-12 shadow-2xl border border-white/10">
              <div className="text-[#FFF8F0] text-xs font-semibold tracking-[0.2em] uppercase mb-4 flex items-center gap-2">
                <span className="w-2 h-2 bg-[#E67E22] rounded-full"></span>
                Premium Outdoor Living Specialists
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold text-white leading-[1.15] mb-5">
                Luxury Landscaping & Outdoor Living
              </h1>
              <div className="text-2xl font-semibold text-[#E67E22] mb-6">
                Serving Glen Mills, Media & Delaware County
              </div>
              <p className="text-base text-[#FFF8F0]/90 mb-8 leading-relaxed border-l-2 border-[#E67E22] pl-4">
                Landscape Design • Patios • Outdoor Living • Lighting • Drainage • Maintenance
              </p>
              <div className="flex flex-wrap gap-4 mb-6">
                <a href="#estimate" className="bg-black text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-900 transition-all shadow-xl flex items-center gap-2 whitespace-nowrap cursor-pointer">
                  <span className="w-2 h-2 bg-[#E67E22] rounded-full"></span>
                  Request Free Estimate
                </a>
                <a href="#gallery" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-black transition-all whitespace-nowrap cursor-pointer">
                  View Portfolio →
                </a>
              </div>
              <div className="flex flex-wrap items-center gap-6 text-sm text-[#FFF8F0]/80">
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-[#E67E22]"></i>
                  Licensed & Insured
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-time-line text-[#E67E22]"></i>
                  15+ Years
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-trophy-line text-[#E67E22]"></i>
                  200+ Projects
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Location Badge */}
        <div className="absolute top-24 right-6 bg-white/95 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg flex items-center gap-2">
          <i className="ri-map-pin-line text-[#E67E22]"></i>
          <span className="text-sm font-semibold text-gray-900 whitespace-nowrap">Glen Mills, PA</span>
        </div>
      </div>
    </div>
  );
}